import type {
  HeroSection,
  MissionSection,
  AboutSection,
  LeverageSectionData,
  FooterSection,
} from '../pages/BrandStory';

export type HomePageSection =
  | HeroSection
  | MissionSection
  | AboutSection
  | LeverageSectionData
  | FooterSection;

export interface HomePage {
  title: string;
  description: string;
  sections: HomePageSection[];
  meta?: Record<string, any>;
  isActive?: boolean;
}

export const DEFAULT_HOME_SECTIONS: HomePageSection[] = [
  {
    type: 'hero',
    title: '<b style="display:block; font-size:0.4em; font-weight:500; letter-spacing:0.05em; margin-bottom:0.4rem;">WELCOME TO ALEX KITCHEN</b> <b style="display:block;">主廚嚴選 · 辣得起 · 有質素</b>',
    subtitle: '阿力廚房 by Chef Alex',
    description:
      '私房菜主廚 Alex 用多年廚藝同網絡，親自為你揀選真正值得入廚房的好食材。皇牌 X1493 真辣系列，九年匠心之作，由廚房直送到你屋企。\n滿 HK$350 起即安排快遞配送 · FPS / PayMe 付款。',
    backgroundImage: '/media/story/hero.jpg',
    ctaPrimary: { label: '瀏覽主廚推介', url: '#shop' },
    ctaSecondary: { label: '認識 Alex', url: '/about' },
  },
  {
    type: 'mission',
    title: '主廚嚴選，質素為先',
    description:
      '網上選購食材，品質往往難以掌握。阿力廚房每一件產品，均由私房菜主廚 Alex 親自挑選與試用，確保達到私廚廚房的使用水準。\n\n從皇牌 X1493 真辣系列、手工辣椒油，到各款優質食材，我們堅持只選能夠煮出好菜的貨品，不求量多，但求對味。',
    values: [
      { title: '主廚把關', description: 'Alex 親自把關好食材，確保每件產品都達到私廚級水準。' },
      { title: '九年口碑', description: '皇牌 X1493 真辣系列自 2016 年起堅持小批量製作，辣得天然有層次。' },
      { title: '香港本地', description: '本地出品、新鮮製作，滿 HK$350 起即可安排港九新界快遞配送。' },
    ],
  },
  {
    type: 'about',
    title: '關於 Chef Alex',
    description:
      'Alex 係一位香港私房菜主廚，多年來為食客炮製精緻菜式，對食材同辣味有近乎固執的堅持。\n\n2016 年，他創立 X-1493 真辣系列，由一款天然真辣粉開始，做到今日成為不少識食之人廚房必備的調味品。九年過去，X1493 依然堅持小批量製作、香港本地出品，辣得天然、辣得有層次。\n\n而家 Alex 透過阿力廚房，將自己多年累積的廚師網絡同嚴選眼光帶到網上——<span class="text-[#C2410C] font-bold text-lg">唔係乜都賣，淨係賣佢真心推介、自己都用開嘅好嘢。</span>',
    imageUrl: '/media/story/chef-alex.jpg',
    imageAlt: 'Chef Alex',
  },
  {
    type: 'footer',
    logoUrl: '/logo.jpg',
    address: '新界葵涌永健路16至20號高威工業中心A座501室',
    phone: '60771493',
    whatsapp: '60771493',
    email: 'support@alexkitchens.com',
    facebookUrl: 'https://www.facebook.com/alexkitchens',
    copyright: '© 2026 阿力廚房 Alex Kitchen. All rights reserved.',
    facebookIcon: '/media/story/facebook-icon.png',
  },
];
